export const RECEIPT_DETAILS_REQUESTED = 'RECEIPT_DETAILS_REQUESTED'
export const RECEIPT_DETAILS_SUCCEEDED = 'RECEIPT_DETAILS_SUCCEEDED'
export const RECEIPT_DETAILS_FAILED = 'RECEIPT_DETAILS_FAILED'
export const CLEAR_RECEIPT_DETAILS = 'CLEAR_RECEIPT_DETAILS'

export const getReceiptDetails = (payload) => ({
  type: RECEIPT_DETAILS_REQUESTED,
  payload
})
  
getReceiptDetails.type = RECEIPT_DETAILS_REQUESTED
  
export const receiptDetailsSucceeded = (payload) => ({
  type: RECEIPT_DETAILS_SUCCEEDED,
  payload
})

export const receiptDetailsFailed = (payload) => ({
  type: RECEIPT_DETAILS_FAILED,
  payload
})

export const clearReceiptDetails = (payload) => ({
  type: CLEAR_RECEIPT_DETAILS,
})
